export default {
      id: "messaging-menu-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#messaging-menu-usage",
      toString: function () {
        return this.url;
      }
    }